export const baseURL = 'https://real-gray-barnacle-wrap.cyclic.cloud';
export const baseURL1 = 'https://moil-jobboarding.netlify.app';

